const hydratePriceNumberInputs = (root = document) => {
  root.querySelectorAll('price-range').forEach((priceRange) => {
    const lowerRange = priceRange.querySelector('[data-price-range-lower]');
    const upperRange = priceRange.querySelector('[data-price-range-upper]');
    const lowerNumber = priceRange.querySelector('[data-price-number-lower]');
    const upperNumber = priceRange.querySelector('[data-price-number-upper]');
    if (!lowerRange || !upperRange || !lowerNumber || !upperNumber) return;
    const min = Number(priceRange.dataset.min || lowerRange.min || 0);
    const max = Number(priceRange.dataset.max || upperRange.max || 0);
    const lower = Number(lowerRange.value);
    const upper = Number(upperRange.value);
    if (!lowerNumber.value && Number.isFinite(lower) && lower > min) lowerNumber.value = lower;
    if (!upperNumber.value && Number.isFinite(upper) && upper < max) upperNumber.value = upper;
  });
};

const schedulePriceNumberHydration = () => {
  requestAnimationFrame(() => requestAnimationFrame(() => hydratePriceNumberInputs()));
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', schedulePriceNumberHydration, { once: true });
} else {
  schedulePriceNumberHydration();
}
window.addEventListener('load', schedulePriceNumberHydration, { once: true });
window.addEventListener('pageshow', schedulePriceNumberHydration);
document.addEventListener('click', (event) => {
  if (event.target.closest('.mobile-facets__open, .mobile-facets__summary')) schedulePriceNumberHydration();
}, true);
document.addEventListener('focusin', (event) => {
  if (event.target.closest('price-range')) schedulePriceNumberHydration();
});
new MutationObserver((records) => {
  if (records.some((record) => record.addedNodes.length > 0)) schedulePriceNumberHydration();
}).observe(document.documentElement, { childList: true, subtree: true });

const preserveSearchQueryScope = (searchParams) => {
  if (!document.querySelector('.template-search')) return searchParams;
  const incomingParams = new URLSearchParams(searchParams);
  const currentParams = new URLSearchParams(window.location.search);
  ['type', 'options[prefix]'].forEach((key) => {
    incomingParams.delete(key);
    currentParams.getAll(key).forEach((value) => incomingParams.append(key, value));
  });
  return incomingParams.toString();
};

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    const requestId = ++FacetFiltersForm.renderRequestId;
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const facetDrawer = document.getElementById('FacetDrawer');
    const countContainer = document.getElementById('ProductCount');
    const countContainerMobile = document.getElementById('ProductCountMobile');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }   
    if (countContainerMobile){
      countContainerMobile.classList.add('loading');
    } 
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }
    if (facetDrawer){
      facetDrawer.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, requestId) :
        FacetFiltersForm.renderSectionFromFetch(url, event, requestId, searchParams);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    
    document.dispatchEvent(new CustomEvent('collection:reloaded'));
  }

  static renderSectionFromFetch(url, event, requestId, searchParams) {
    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(`FILTER_REQUEST_${response.status}`);
        return response.text();
      })
      .then((responseText) => {
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html: responseText, url }];
        if (requestId !== FacetFiltersForm.renderRequestId) return;
        FacetFiltersForm.renderFilters(responseText, event);
        FacetFiltersForm.renderProductGridContainer(responseText);
        FacetFiltersForm.renderProductCount(responseText);
      })
      .catch((error) => {
        if (requestId !== FacetFiltersForm.renderRequestId) return;
        console.error(error);
        document.getElementById('ProductGridContainer')?.querySelector('.collection')?.classList.remove('loading');
        document.getElementById('FacetDrawer')?.classList.remove('loading');
        const fallback = `${window.location.pathname}${searchParams ? `?${searchParams}` : ''}`;
        window.location.assign(fallback);
      });
  }

  static renderSectionFromCache(filterDataUrl, event, requestId) {
    if (requestId !== FacetFiltersForm.renderRequestId) return;
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    
    const layoutSwitcher = document.querySelector('#FacetSortFiltersForm layout-switcher');
    if (layoutSwitcher) layoutSwitcher.onButtonClick(layoutSwitcher.querySelector('.list-view__item--active'));
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerMobile = document.getElementById('ProductCountMobile');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerMobile) {
      containerMobile.innerHTML = count;
      containerMobile.classList.remove('loading');
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElementsFromFetch =
      parsedHTML.querySelectorAll('#FacetSortFiltersForm .js-filter, #FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const facetDetailsElementsFromDom =
      document.querySelectorAll('#FacetSortFiltersForm .js-filter, #FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId)?.after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          const isMobileFacet = elementToRender.id.startsWith('Details-Mobile-') || elementToRender.id.startsWith('Div-Mobile-');
          const destination = isMobileFacet
            ? document.getElementById('FacetFiltersFormMobile')
            : document.querySelector('#FacetFiltersForm .facets__main');
          const firstFacet = destination?.querySelector('.js-filter');
          if (firstFacet) firstFacet.before(elementToRender);
          else destination?.append(elementToRender);
        }
      }
    });

    FacetFiltersForm.orderFacetGroups();

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const currentFilter = event.target.closest('.js-filter');
      FacetFiltersForm.renderCounts(countsToRender, currentFilter);
      currentFilter?.querySelector('price-range')?.syncNumbersFromRanges();
    }

    const facetDrawer = document.getElementById('FacetDrawer');
    if (facetDrawer) {
      facetDrawer.classList.remove('loading');
    }
  }

  static orderFacetGroups() {
    const order = { equipment: 10, brand: 20, price: 30, other: 40, sort: 50 };
    document.querySelectorAll('#FacetFiltersForm .facets__main, #FacetFiltersFormMobile').forEach((container) => {
      const facetElements = [...container.children].filter((element) => element.matches('.js-filter[data-cs-facet-group]'));
      facetElements.sort((a, b) => (order[a.dataset.csFacetGroup] || 40) - (order[b.dataset.csFacetGroup] || 40));
      const firstNonFacet = [...container.children].find((element) => !element.matches('.js-filter[data-cs-facet-group]'));
      facetElements.forEach((element) => firstNonFacet ? firstNonFacet.before(element) : container.append(element));
    });
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.facets__open', '.sorting', '[data-cs-active-overview]', '#FacetFiltersFormMobile > .mobile-facets__footer'];

    mobileElementSelectors.forEach((selector) => {
      const incoming = html.querySelector(selector);
      const current = document.querySelector(selector);
      if (!incoming) {
        current?.remove();
        return;
      }
      if (current) {
        current.innerHTML = incoming.innerHTML;
      } else if (selector === '[data-cs-active-overview]') {
        document.querySelector('.mobile-facets__header')?.after(incoming);
      }
    });

    document.getElementById('FacetFiltersFormMobile').closest('facet-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    const sourceFooter = source.querySelector('.mobile-facets__footer');
    const targetFooter = target.querySelector('.mobile-facets__footer');
    if (sourceFooter && targetFooter) targetFooter.innerHTML = sourceFooter.innerHTML;
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    const grid = document.getElementById('product-grid') || document.querySelector('#ProductGridContainer [data-id]');
    return [
      {
        section: grid.dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData);
    ['filter.v.price.gte', 'filter.v.price.lte'].forEach((key) => {
      if (searchParams.get(key) === '') searchParams.delete(key);
    });
    return searchParams;
  }

  mergeSearchParams(form, searchParams) {
    const params = this.createSearchParams(form);
    params.forEach((value, key) => {
      searchParams.append(key, value);
    });
    return searchParams;
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(preserveSearchQueryScope(searchParams), event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const currentForm = event.target.closest('form');
    if (currentForm.id === 'FacetFiltersFormMobile') {
      const searchParams = this.createSearchParams(currentForm);
      this.onSubmitForm(searchParams.toString(), event);
    }
    else {
      let searchParams = new URLSearchParams();

      if (currentForm.id === 'FacetSortFiltersForm' && currentForm.dataset.filterType === 'drawer') {
        const mobileForm = document.getElementById('FacetFiltersFormMobile');
        searchParams = this.mergeSearchParams(mobileForm, searchParams);
        searchParams.delete('sort_by');
      }
  
      const sortFilterForms = document.querySelectorAll('facet-filters-form form');
      sortFilterForms.forEach((form) => {
        if (form.id === 'FacetFiltersForm' || form.id === 'FacetSortFiltersForm') {
          searchParams = this.mergeSearchParams(form, searchParams);
        }
      });

      this.onSubmitForm(searchParams.toString(), event);
    }
    /*
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
    */
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.renderPage(preserveSearchQueryScope(new URL(event.currentTarget.href).searchParams.toString()));
  }
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.renderRequestId = 0;
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class FacetRemove extends HTMLElement {
  constructor() {
    super();

    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}
customElements.define('facet-remove', FacetRemove);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.priceRangeInitialized = false;
  }

  connectedCallback() {
    if (this.priceRangeInitialized) return;
    this.lowerRange = this.querySelector('[data-price-range-lower]');
    this.upperRange = this.querySelector('[data-price-range-upper]');
    this.lowerNumber = this.querySelector('[data-price-number-lower]');
    this.upperNumber = this.querySelector('[data-price-number-upper]');
    this.lowerOutput = this.querySelector('[data-price-range-lower-output]');
    this.upperOutput = this.querySelector('[data-price-range-upper-output]');
    this.min = Number(this.dataset.min || 0);
    this.max = Number(this.dataset.max || 0);
    if (!this.lowerRange || !this.upperRange || !this.lowerNumber || !this.upperNumber) return;
    this.priceRangeInitialized = true;
    this.hydrateNumbersFromUrl();

    this.lowerRange.addEventListener('input', (event) => this.onRangeInput(event, 'lower'));
    this.upperRange.addEventListener('input', (event) => this.onRangeInput(event, 'upper'));
    this.lowerRange.addEventListener('change', (event) => this.commit(event));
    this.upperRange.addEventListener('change', (event) => this.commit(event));
    this.lowerNumber.addEventListener('input', (event) => this.onNumberInput(event, 'lower'));
    this.upperNumber.addEventListener('input', (event) => this.onNumberInput(event, 'upper'));
    this.lowerNumber.addEventListener('change', (event) => this.onNumberChange(event, 'lower'));
    this.upperNumber.addEventListener('change', (event) => this.onNumberChange(event, 'upper'));
    this.syncFromNumbers();
  }

  hydrateNumbersFromUrl() {
    const params = new URLSearchParams(window.location.search);
    if (!this.lowerNumber.value && params.has(this.lowerNumber.name)) {
      this.lowerNumber.value = params.get(this.lowerNumber.name) || '';
    }
    if (!this.upperNumber.value && params.has(this.upperNumber.name)) {
      this.upperNumber.value = params.get(this.upperNumber.name) || '';
    }
  }

  numberOr(value, fallback) {
    if (value === '' || value === null || value === undefined) return fallback;
    const number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  clamp(value) {
    return Math.min(this.max, Math.max(this.min, value));
  }

  onRangeInput(event, side) {
    event.stopPropagation();
    let lower = this.clamp(this.numberOr(this.lowerRange.value, this.min));
    let upper = this.clamp(this.numberOr(this.upperRange.value, this.max));
    if (side === 'lower' && lower > upper) lower = upper;
    if (side === 'upper' && upper < lower) upper = lower;
    this.lowerRange.value = lower;
    this.upperRange.value = upper;
    this.lowerNumber.value = lower === this.min ? '' : lower;
    this.upperNumber.value = upper === this.max ? '' : upper;
    this.render(lower, upper);
  }

  syncNumbersFromRanges() {
    const lower = this.clamp(this.numberOr(this.lowerRange.value, this.min));
    const upper = this.clamp(this.numberOr(this.upperRange.value, this.max));
    this.lowerNumber.value = lower === this.min ? '' : lower;
    this.upperNumber.value = upper === this.max ? '' : upper;
    this.render(lower, upper);
  }

  onNumberInput(event) {
    event.stopPropagation();
    this.syncFromNumbers();
  }

  onNumberChange(event, side) {
    event.stopPropagation();
    let lower = this.clamp(this.numberOr(this.lowerNumber.value, this.min));
    let upper = this.clamp(this.numberOr(this.upperNumber.value, this.max));
    if (side === 'lower' && lower > upper) lower = upper;
    if (side === 'upper' && upper < lower) upper = lower;
    this.lowerNumber.value = this.lowerNumber.value === '' && lower === this.min ? '' : lower;
    this.upperNumber.value = this.upperNumber.value === '' && upper === this.max ? '' : upper;
    this.lowerRange.value = lower;
    this.upperRange.value = upper;
    this.render(lower, upper);
    this.commit(event);
  }

  syncFromNumbers() {
    let lower = this.clamp(this.numberOr(this.lowerNumber.value, this.min));
    let upper = this.clamp(this.numberOr(this.upperNumber.value, this.max));
    if (lower > upper) lower = upper;
    this.lowerRange.value = lower;
    this.upperRange.value = upper;
    this.render(lower, upper);
  }

  render(lower, upper) {
    const span = this.max - this.min || 1;
    const lowerProgress = ((lower - this.min) / span) * 100;
    const upperProgress = ((upper - this.min) / span) * 100;
    this.style.setProperty('--progress-lower', `${lowerProgress}%`);
    this.style.setProperty('--progress-upper', `${upperProgress}%`);
    if (this.lowerOutput) this.lowerOutput.value = lower;
    if (this.upperOutput) this.upperOutput.value = upper;
    const currency = this.dataset.currency || '';
    this.lowerRange.setAttribute('aria-valuetext', `${currency}${lower}`);
    this.upperRange.setAttribute('aria-valuetext', `${currency}${upper}`);
  }

  commit(event) {
    event.stopPropagation();
    this.dispatchEvent(new Event('input', { bubbles: true }));
  }
}
customElements.define('price-range', PriceRange);

class LayoutSwitcher extends HTMLElement {
	constructor() {
    super();

    this.cookieName = 'beyours:collection-layout';

    this.initLayoutMode();
    this.querySelectorAll('.list-view__item').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
	}
	
  onButtonClick(event) {
    const target = event.target ? event.target : event;
    this.changeLayoutMode(target, target.dataset.layoutMode);
  }

  initLayoutMode() {
    if (isStorageSupported('local')) {
      const layoutMode = window.localStorage.getItem(this.cookieName);

      if (layoutMode !== null) {
        const target = this.querySelector(`.list-view__item[data-layout-mode="${layoutMode}"]`);

        if (target) {
          this.changeLayoutMode(target, layoutMode);
        }
      }
    }
  }

  changeLayoutMode(target, layoutMode) {
    const productGrid = document.getElementById('product-grid');

    if (!productGrid || productGrid.classList.contains('collection--empty')) {
      return;
    }

    const removedClass = ['list', 'flex-grid', 'flex-grid--1-col', 'flex-grid--2-col', 'flex-grid--3-col-tablet', 'flex-grid--2-col-desktop', 'flex-grid--3-col-desktop', 'flex-grid--4-col-desktop'];
    removedClass.forEach((removed) => {
      productGrid.classList.remove(removed);
    });

    let addedClass = [];
    switch (layoutMode) {
      case 'list':
        addedClass = ['flex-grid', 'flex-grid--1-col', 'flex-grid--2-col-desktop', 'list'];
        break;

      case 'grid-2':
        addedClass = ['flex-grid', 'flex-grid--2-col'];
        break;

      case 'grid-3':
        addedClass = ['flex-grid', 'flex-grid--2-col', 'flex-grid--3-col-tablet', 'flex-grid--3-col-desktop'];
        break;

      case 'grid-4':
        addedClass = ['flex-grid', 'flex-grid--2-col', 'flex-grid--3-col-tablet', 'flex-grid--4-col-desktop'];
        break;
    }
    addedClass.forEach((added) => {
      productGrid.classList.add(added);
    });

    this.querySelectorAll('.list-view__item').forEach(
      (button) => button.classList.remove('list-view__item--active')
    );

    target.classList.add('list-view__item--active');

    if (isStorageSupported('local')) {
      window.localStorage.setItem(this.cookieName, layoutMode);
    }
  }
}
customElements.define('layout-switcher', LayoutSwitcher);

class StickyFacetFilters extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.onScrollHandler = this.onScroll.bind(this);

    window.addEventListener('scroll', this.onScrollHandler, false);
    this.onScrollHandler();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.parentNode.offsetTop) {
      window.requestAnimationFrame(this.reveal.bind(this));
    } else {
      window.requestAnimationFrame(this.reset.bind(this));
    }
  }

  reveal() {
    this.classList.add('shopify-section-filters-sticky');
  }

  reset() {
    this.classList.remove('shopify-section-filters-sticky');
  }
}
customElements.define('sticky-facet-filters', StickyFacetFilters);

class FacetValueSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('[data-facet-value-search]');
    this.empty = this.querySelector('.facet-value-search__empty');
    this.filter = this.closest('.js-filter');
    if (!this.input || !this.filter) return;
    this.input.addEventListener('input', (event) => {
      event.stopPropagation();
      this.filterValues(event.currentTarget.value);
    });
  }

  filterValues(query) {
    const normalized = query.trim().toLocaleLowerCase();
    const list = this.filter.querySelector('.facets__list, .mobile-facets__list');
    const items = list ? [...list.querySelectorAll('.facets__item')] : [];
    let matches = 0;
    items.forEach((item) => {
      const checked = Boolean(item.querySelector('input:checked'));
      const match = !normalized || item.textContent.toLocaleLowerCase().includes(normalized) || checked;
      item.hidden = !match;
      if (match) matches += 1;
    });
    const showMore = this.filter.querySelector('show-more-button');
    if (showMore) {
      showMore.hidden = Boolean(normalized);
      if (!normalized) showMore.restoreVisibility();
    }
    if (this.empty) this.empty.hidden = matches > 0;
  }
}
customElements.define('facet-value-search', FacetValueSearch);

class ShowMoreButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.button-show-more');
    this.filter = this.closest('.js-filter');
    if (!this.button || !this.filter) return;
    this.filter.removeAttribute('aria-expanded');
    this.expanded = false;
    this.button.addEventListener('click', () => {
      this.expanded = !this.expanded;
      this.restoreVisibility();
    });
    this.restoreVisibility();
  }

  restoreVisibility() {
    const items = this.filter.querySelectorAll('.facets__item--alt');
    items.forEach((item) => { item.hidden = !this.expanded; });
    this.button.setAttribute('aria-expanded', String(this.expanded));
    const more = this.button.querySelector('.label-show-more');
    const less = this.button.querySelector('.label-show-less');
    if (more) more.hidden = this.expanded;
    if (less) less.hidden = !this.expanded;
  }
}
customElements.define('show-more-button', ShowMoreButton);


document.querySelectorAll('facet-drawer').forEach((drawer) => {
  drawer.addEventListener('close', () => {
    const summary = drawer.querySelector(':scope > details > summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  });
});

const enhanceContextualFacetDrawer = (drawer) => {
  if (!drawer || drawer.dataset.csContextualReady === 'true') return;
  drawer.dataset.csContextualReady = 'true';
  const mainDetails = drawer.querySelector(':scope > details');
  const mainSummary = mainDetails?.querySelector(':scope > summary');
  const drawerPanel = drawer.querySelector('.mobile-facets__inner');
  const browserDetails = drawer.querySelector('[data-cs-browser-details]');
  const browserSummary = browserDetails?.querySelector(':scope > summary');
  const browserBack = browserDetails?.querySelector('[data-cs-browser-back]');
  const browserPanel = browserDetails?.querySelector('.cs-mobile-browser-submenu');
  let drawerPanelTrapKeydown;

  const isVisibleFocusable = (element) => {
    if (!element || element.hidden || element.disabled) return false;
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity || 1) > 0;
  };

  const getVisibleDrawerFocusables = () => drawerPanel ? [...drawerPanel.querySelectorAll('summary, a[href], button:enabled, input:not([type="hidden"]):enabled, select:enabled, textarea:enabled, [tabindex]:not([tabindex^="-"])')].filter(isVisibleFocusable) : [];

  const removeDrawerPanelTrap = () => {
    if (!drawerPanelTrapKeydown || !drawerPanel) return;
    drawerPanel.removeEventListener('keydown', drawerPanelTrapKeydown, true);
    drawerPanelTrapKeydown = undefined;
  };

  const trapDrawerPanelFocus = () => {
    if (!mainDetails?.open || !drawerPanel) return;
    const focusables = getVisibleDrawerFocusables();
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (!first || !last) return;
    removeTrapFocus();
    trapFocus(drawerPanel, first);
    removeDrawerPanelTrap();
    drawerPanelTrapKeydown = (event) => {
      if (event.key !== 'Tab') return;
      const visibleFocusables = getVisibleDrawerFocusables();
      const firstVisible = visibleFocusables[0];
      const lastVisible = visibleFocusables[visibleFocusables.length - 1];
      if (!firstVisible || !lastVisible || !drawerPanel.contains(document.activeElement)) return;
      if (!event.shiftKey && document.activeElement === lastVisible) {
        event.preventDefault();
        event.stopPropagation();
        firstVisible.focus();
      } else if (event.shiftKey && document.activeElement === firstVisible) {
        event.preventDefault();
        event.stopPropagation();
        lastVisible.focus();
      }
    };
    drawerPanel.addEventListener('keydown', drawerPanelTrapKeydown, true);
    first.focus();
  };

  const trapBrowserPanelFocus = () => {
    if (!browserPanel || !browserBack) return;
    removeDrawerPanelTrap();
    removeTrapFocus();
    trapFocus(browserPanel, browserBack);
  };

  const restoreDrawerFocus = () => {
    if (!mainDetails?.open || !drawerPanel) return;
    trapDrawerPanelFocus();
  };

  mainSummary?.addEventListener('click', () => {
    if (mainDetails?.open) return;
    window.setTimeout(() => {
      const expandedBrowser = drawer.querySelector('[data-cs-browser-details][open]');
      const expandedBrowserBack = expandedBrowser?.querySelector('[data-cs-browser-back]');
      const expandedBrowserPanel = expandedBrowser?.querySelector('.cs-mobile-browser-submenu');
      if (expandedBrowserPanel && expandedBrowserBack) {
        trapBrowserPanelFocus();
      } else {
        trapDrawerPanelFocus();
      }
    }, 140);
  });

  mainDetails?.addEventListener('toggle', () => {
    mainSummary?.setAttribute('aria-expanded', String(mainDetails.open));
    if (mainDetails.open) return;
    removeDrawerPanelTrap();
    removeTrapFocus();
    window.setTimeout(() => mainSummary?.focus(), 0);
  });

  browserSummary?.addEventListener('click', () => {
    if (browserDetails?.open) return;
    window.setTimeout(() => {
      if (!browserDetails?.open || !browserPanel || !browserBack) return;
      trapBrowserPanelFocus();
    }, 140);
  });

  browserBack?.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!browserDetails?.open) return;
    if (typeof drawer.closeSubmenu === 'function') {
      drawer.closeSubmenu(browserDetails);
      return;
    }
    drawer.querySelector('[data-cs-drawer-heading]')?.focus();
    browserDetails.open = false;
    browserDetails.classList.remove('menu-opening');
    browserSummary?.setAttribute('aria-expanded', 'false');
  }, { capture: true });

  browserBack?.addEventListener('keydown', (event) => {
    if (event.key !== ' ' && event.key !== 'Enter') return;
    event.preventDefault();
    browserBack.click();
  });

  browserDetails?.addEventListener('toggle', () => {
    browserSummary?.setAttribute('aria-expanded', String(browserDetails.open));
    if (!browserDetails.open) window.setTimeout(restoreDrawerFocus, 500);
  });
};

document.querySelectorAll('facet-drawer').forEach(enhanceContextualFacetDrawer);

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-cs-branch-toggle]');
  if (!toggle) return;
  const list = toggle.nextElementSibling;
  if (!list) return;
  const expanded = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!expanded));
  list.hidden = expanded;
});
